import styled from "styled-components";

export const ProductPresentationFeatureCardContainer = styled.div`
  transition: all 0.2s ease-in-out;

  gap: 1rem;

  background-color: #ffffff0d;

  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;

  padding: 1.5rem;
  border-radius: 4px;
  border: 1px solid #ffffff1a;

  position: relative;

  overflow: hidden;

  width: 100%;

  @media (min-width: 980px) {
    gap: 0.5rem;
  }

  @media (min-width: 1300px) {
    gap: 1rem;
  }

  &::before {
    content: "";
    transition: all 0.2s ease-in-out;

    position: absolute;

    background-color: transparent;

    top: 50%;
    left: 10%;

    height: 0px;
    width: 0px;

    z-index: 1;

    box-shadow: ${({ theme }) => `0px 0px 230px 60px ${theme.colors.primary}`};
  }

  ::after {
    content: "";
    position: absolute;

    top: 0;
    left: 0;

    height: 100%;
    width: 100%;

    backdrop-filter: blur(15px);
  }

  > svg {
    min-height: 1.5rem;
    height: 1.5rem;
    width: 1.5rem;

    z-index: 1;

    * {
      fill: ${({ theme }) => theme.colors.primary};
    }

    @media (min-width: 1300px) {
      min-height: 2rem;
      height: 2rem;
      width: 2rem;
    }
  }
`;

export const ProductPresentationFeatureCardParagraph = styled.span`
  font: 600 1.125rem/1.125rem "Inter";
  color: #ffffff !important;

  line-height: 1.2rem;

  text-align: center;

  z-index: 2;

  @media (min-width: 980px) {
    font: 600 0.875rem/1.125rem "Inter";
  }

  @media (min-width: 1300px) {
    font: 600 1rem/1.5rem "Inter";
  }
`;
